// src/Api/services/paymentService.ts

import { PostPaymentResponse } from "../../Types/Payment";
import api from "../axios";
import { ENDPOINTS } from "../endpoints";

export const paymentService = {
  postPayment: (id: string) =>
    api.post<PostPaymentResponse>(`${ENDPOINTS.PAYMENTS}/send-email`, { id }),
  postRentalPayment: (id: string, type: string) =>
    api.post<PostPaymentResponse>(`${ENDPOINTS.PAYMENTS}/send-product-email`, {
      id,
      type,
    }),
};
